import { useTranslation } from 'react-i18next';

import { getHttpErrorMessage, hasHttpFieldError } from '_utils/http';

import { useAskMessage } from '_modules/message/hooks/useServices';
import { createMessage } from '_modules/message/utils';

import { useChatContext } from './useContext';

export const useChat = () => {
  const { t } = useTranslation('chat');
  const { dispatch, state } = useChatContext();
  const { mutateAsync } = useAskMessage();

  const send = async (question: string) => {
    const parsedQuestion = question.trim();

    if (!parsedQuestion || state.isLoading) return;

    const pending = createMessage({
      content: '',
      pending: true,
      role: 'ASSISTANT',
    });
    const patchPending = (content: string) =>
      dispatch({
        changes: { content, pending: false },
        id: pending.id,
        type: 'patchMessage',
      });

    dispatch({
      message: createMessage({ content: parsedQuestion, role: 'USER' }),
      type: 'appendMessage',
    });
    dispatch({ message: pending, type: 'appendMessage' });
    dispatch({ type: 'askStarted' });

    try {
      const response = await mutateAsync({
        conversationId: state.conversationId,
        onDelta: patchPending,
        question: parsedQuestion,
      });

      dispatch({
        conversationId: response.conversationId,
        type: 'askSucceeded',
      });
      patchPending(response.answer);
    } catch (error) {
      dispatch({
        resetConversation: hasHttpFieldError(error, 'conversationId'),
        type: 'askFailed',
      });
      patchPending(getHttpErrorMessage(error) ?? t('message.error'));
    }
  };

  return { send };
};
